import { render, staticRenderFns } from "./AdquisicionAliados.vue?vue&type=template&id=172601be&scoped=true&lang=html&"
import script from "./AdquisicionAliados.vue?vue&type=script&lang=js&"
export * from "./AdquisicionAliados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172601be",
  null
  
)

export default component.exports